import { useAuth } from "../contexts/AuthContext";
export var useUserMetadataField = function (field) {
    var _a;
    var user = useAuth().user;
    return (_a = user === null || user === void 0 ? void 0 : user.user_metadata) === null || _a === void 0 ? void 0 : _a[field];
};
